import v3ApiClient from "./client";

const USER_PREFIX = "/v3/user";

function unwrapUserPreferencePayload(response) {
    return response?.data?.data ?? response?.data ?? response;
}

function encodePathPart(value) {
    return encodeURIComponent(String(value));
}

export const userPreferenceApi = {
    listPreferences: async ({ scope } = {}) => {
        const response = await v3ApiClient.get(`${USER_PREFIX}/preferences`, {
            params: { scope },
        });
        return unwrapUserPreferencePayload(response);
    },
    getPreference: async ({ scope, key } = {}) => {
        const payload = await userPreferenceApi.listPreferences({ scope });
        const item = (payload?.items || []).find((preference) => preference.key === key);
        return item?.value ?? null;
    },
    upsertPreference: async ({ scope, key, value } = {}) => {
        const response = await v3ApiClient.put(`${USER_PREFIX}/preferences/${encodePathPart(scope)}/${encodePathPart(key)}`, {
            value,
        });
        return unwrapUserPreferencePayload(response);
    },
    deletePreference: async ({ scope, key } = {}) => {
        const response = await v3ApiClient.delete(`${USER_PREFIX}/preferences/${encodePathPart(scope)}/${encodePathPart(key)}`);
        return unwrapUserPreferencePayload(response);
    },
};

export default userPreferenceApi;
